<template>
  <main class="html-page">
    <main><section class="page-hero"><div class="container"><p class="eyebrow">Diagnóstico por imagem</p><h1 id="exam-title">Tomografia Computadorizada</h1><p id="exam-summary">Avaliação detalhada e de alta resolução para apoiar a investigação diagnóstica.</p></div></section><section class="section"><div class="split container"><img src="/site-assets/layouts/imaginarvet-2008/assets/images/tech-dog.jpg" alt="Exame veterinário na Imaginar" style="height:520px;border-radius:24px"><div class="split-copy"><p class="eyebrow">Sobre o exame</p><h2>Informações claras em cada etapa.</h2><p id="exam-text">A tomografia utiliza um aparelho de raio-X que gira ao redor do paciente e produz imagens transversais convertidas em cortes tomográficos. A técnica permite avaliar estruturas internas com precisão.</p><p>O preparo varia conforme o exame e a condição do paciente. Entre em contato com a equipe para receber as orientações adequadas.</p><a class="btn btn-primary" href="https://wa.me/5551991544590">Agendar pelo WhatsApp</a></div></div></section></main><a class="whatsapp" href="https://wa.me/5551991544590">◔</a>
    
  </main>
</template>

<script>
export default {
  name: 'ExameDetalheView',
  mounted() {
    document.title = "Detalhe do Exame | Imaginar";
  },
};
</script>
